import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { notify } from 'components/notification/notificationSlice';
import { DocumentDuplicateIcon } from 'components/icons';
import { useAppDispatch } from 'hooks';

const CopyToClipboardButton = ({ value }: { value: string }) => {
  const { t } = useTranslation('bank');
  const dispatch = useAppDispatch();

  const [isGreen, setIsGreen] = useState<boolean>(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value || '');

    setIsGreen(true);

    dispatch(
      notify({
        message: 'common:notifications.copiedToClipboard',
        duration: 2000,
      }),
    );
  };

  return (
    <button
      className="flex items-center justify-center w-10 h-10 disabled:opacity-50"
      onClick={handleCopy}
      title={t('common:copy')}
      disabled={!value}
      type="button"
    >
      <DocumentDuplicateIcon
        className={`text-${isGreen ? 'green' : 'gray'}-500 w-5 h-5`}
      />
    </button>
  );
};

export default CopyToClipboardButton;
